import React from 'react';


const CartProduct =({name , count , price , number , clickMinus , clickPlus , clickDelete})=>{
    return(
        <div className="cart-product">
            <div className="row">
                <div className="col-1">
                    <span className="cart-number">{number}</span>
                </div>
                <div className="col-3">
                    <span className="cart-name">{name}</span>
                </div>
                <div className="col-2">
                    <span className="cart-count">{count}</span>
                </div>
                <div className="col-2">
                    <span className="cart-price">{price}</span>
                </div>
                <div className="col-4 d-flex align-items-center justify-content-end">
                    <div className="cart-action">
                        <button
                        onClick={clickMinus}
                        type="button" className="btn-action">
                            <i className="fa fa-minus"></i>
                        </button>
                        <button
                        onClick={clickPlus}
                        type="button" className="btn-action">
                            <i className="fa fa-plus"></i>
                        </button>
                        <button 
                        onClick={clickDelete}
                        type="button" className="btn-action btn-remove-product">
                            <i className="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CartProduct;